var tinycolor = require('tinycolor2');

function getColorObject(value, name) {
    var c = tinycolor(value);
    return {
        name: name,
        hex: c.toHexString(),
        darkContrast: c.isLight(),
    };
}

function multiply(rgb1, rgb2) {
    rgb1.b = Math.floor(rgb1.b * rgb2.b / 255);
    rgb1.g = Math.floor(rgb1.g * rgb2.g / 255);
    rgb1.r = Math.floor(rgb1.r * rgb2.r / 255);
    return tinycolor('rgb ' + rgb1.r + ' ' + rgb1.g + ' ' + rgb1.b);
}

export default function (hex) {
    var baseLight = tinycolor('#ffffff');
    var baseDark = multiply(tinycolor(hex).toRgb(), tinycolor(hex).toRgb());
    return [
        getColorObject(tinycolor.mix(baseLight, hex, 12), '5'),
        getColorObject(tinycolor.mix(baseLight, hex, 30), '10'),
        getColorObject(tinycolor.mix(baseLight, hex, 50), '20'),
        getColorObject(tinycolor.mix(baseLight, hex, 70), '30'),
        getColorObject(tinycolor.mix(baseLight, hex, 85), '40'),
        getColorObject(tinycolor.mix(baseLight, hex, 100), '50'),
        getColorObject(tinycolor.mix(baseDark, hex, 87), '60'),
        getColorObject(tinycolor.mix(baseDark, hex, 70), '70'),
        getColorObject(tinycolor.mix(baseDark, hex, 54), '80'),
        getColorObject(tinycolor.mix(baseDark, hex, 25), '90'),
        getColorObject(tinycolor.mix(baseDark, hex, 5), '100'),
    ];
}
